module.exports = __webpack_public_path__ + "static/img/home_default_head.e7de2c1a.png";